// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wQ","title":"wR","year":"wS","genres":"wT","buttonWrapper":"wU","button":"wV x7"};